import styled from "styled-components";

import { pxToRem } from "@otta/design-tokens";

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 0;
  flex-grow: 1;
  overflow-y: auto;
  padding: ${pxToRem(24)} ${pxToRem(40)};
`;
